export default {
  signatories: (state) => state.signatories,
  searchParams: (state) => state.searchParams,
  pagination: (state) => state.pagination,
};
